import pickBy from 'lodash/pickBy.js'
import urljoin from 'url-join'
import pkg from '../../package.json'

import { useRuntimeConfig } from '#app'
import { defineNuxtPlugin } from '#imports'
import { useAuthToken } from '~/composables/auth/useAuthToken.js'

// let _apiUrl = null
// function setApiUrl(url) {
//   _apiUrl = url
// }

export default defineNuxtPlugin((nuxtApp) => {
  const { apiUrl, clientId, intranet } = useRuntimeConfig().public
  const { getAuthHeaders, token } = useAuthToken()

  let _errorHandler = null
  function setErrorHandler(handler) {
    _errorHandler = handler
  }

  function isValid(value) {
    return value !== undefined && value !== null
  }

  function _checkToken(req) {
    if (!req.isPublic && !req.token) {
      throw { code: 'ERR_A103', url: req.endpoint }
    }
  }

  // 請求攔截器列表
  const requestInterceptors = []

  // 註冊攔截器
  const addRequestInterceptor = (interceptor) => {
    requestInterceptors.push(interceptor)
    // 返回移除函數
    return () => {
      const index = requestInterceptors.indexOf(interceptor)
      if (index > -1) {
        requestInterceptors.splice(index, 1)
      }
    }
  }

  const request = async (options) => {
    try {
      // 執行攔截器 - 允許修改 options 或進行其他處理
      for (const interceptor of requestInterceptors) {
        // 如果攔截器返回 false，則取消請求（模擬取消）
        // 注意：這裡簡單實作，實際 axios 攔截器更複雜
        const result = interceptor(options)
        if (result === false) {
           // 模擬取消請求
           // throw new DOMException('Aborted by interceptor', 'AbortError')
           // 這裡選擇不拋出錯誤，而是返回一個空的 promise 或類似結構，視需求而定
           // 但為了模擬 axios cancel token，通常這會導致 promise reject
           throw { message: 'Canceled', name: 'CanceledError', __isCancel: true }
        }
      }

      const { url, method, params, isPublic, headers, isFormData = false, signal } = options
      const baseUrl = import.meta.server && intranet === '1' ? 'http://frontend-api-v2.default.svc.cluster.local' : nuxtApp.$fastApiUrl || apiUrl
      const endpoint = urljoin(baseUrl, url.replace(':clientId', clientId))
      _checkToken({ isPublic, endpoint, token: token.value })
      const isGet = method.toLowerCase() === 'get'
      const payloadKey = isGet ? 'query' : 'body'
      const payload = isFormData ? params : pickBy(params, isValid)

      // 不重試的錯誤碼列表
      const NO_RETRY_ERROR_CODES = [
        'ERR_F108', // 維護模式
        'ERR_A103', // Token 無效
        'ERR_G111', // Account Locking
        'ERR_A224', // Login Error
      ]

      const res = await $fetch(endpoint, {
        method,
        headers: {
          'X-TH1GAMES-VERSION': `v${pkg.version}`,
          'X-TH1GAMES-PLATFORM': 'pwa',
          ...getAuthHeaders(),
          ...headers,
        },
        [payloadKey]: payload,
        // ofetch retry 配置
        // retry: ({ response }) => {
        //   const errorCode = response?._data?.error?.code || response?.data?.error?.code
        //   // 不 Retry
        //   if (errorCode && NO_RETRY_ERROR_CODES.includes(errorCode)) {
        //     return 0
        //   }

        //   // 最多 Retry 2 次
        //   return 2
        // },
        retry: 2,
        retryDelay: 1000, // 重試延遲 1 秒（ofetch 會自動使用指數退避）
        retryStatusCodes: [408, 409, 425, 429, 500, 502, 504], // 需要重試的 HTTP 狀態碼
        signal // 傳遞 signal 支援 AbortController
      })

      if (res.data?.error) {
        throw res.data?.error
      }
      return res
    } catch (e) {
      // 忽略取消錯誤
      if (e.__isCancel) {
         console.log('Request canceled by interceptor')
         return { data: {} } // 返回空數據或其他適當的 fallback
      }
      
      console.error('request error:', e)
      if (e.message?.includes('Failed to fetch')) {
        _errorHandler && _errorHandler({ code: 'ERR_998' })
      } else if (e.data) {
        _errorHandler && _errorHandler(e.data.error)
        throw e.data.error
      }
      throw e
    }
  }

  return {
    provide: {
      request: {
        send: request,
        // setApiUrl,
        setErrorHandler,
        addRequestInterceptor
      },
    },
  }
})
